import styled from 'styled-components';
import { Form } from 'antd';
import Card from '$app/components/vendor/Card';
import Title from '../../../components/Title';

const colors = {
  'light-gray': '#D1DADE',
  'content-black': '#201E1E',
};

export const FormItem = styled(Form.Item)``;
export const FormItemGrow = styled(FormItem)`
  flex-grow: 1;

  .ant-form-item-control-wrapper {
    width: 100%;
    display: block;
  }
`;

export const ScrollableDiv = styled.div`
  overflow: auto;
  padding-left: 16px;
`;

export const NotesContainer = styled.div`
  border-radius: 3px;
  .ant-card-bordered {
    border: 1px solid ${colors['light-gray']};
  }
`;
export const listStyle = {
  width: '100%',
  textAlign: 'left',
  display: 'flex',
  marginBottom: '3px',
};

export const listStyleHighlighted = Object.assign({
  background: '#e6f7ff',
  fontWeight: 'bold',
}, listStyle)

export const timeStamp = {
  marginRight: '30px',
  marginBottom: 0,
};

export const timeStampHighlighted = Object.assign({ color: '#2b9cff' }, timeStamp)

export const noteContent = {
  marginBottom: 0,
  color: `${colors['content-black']}`,
  width: '70%',
};

export const noteContentHighlighted = {
  color: '#2b9cff',
  marginBottom: noteContent.marginBottom,
  width: noteContent.width
}

export const StyledList = styled.li`
  margin-top: 10px;
  border-top: 1px solid ${colors['light-gray']};
  display: flex;
  padding-left: 5px !important;
  form {
    display: flex;
    width: 100%;
    #note {
      margin-bottom: 0;
      border: none;
    }
    #note:focus {
      outline: none;
    }
  }
`;

export const SubmitButton = styled.button`
  align-self: flex-end;
  padding-left: 14px;
  padding-right: 0;
  border: none;
  border-left: 1px solid ${colors['light-gray']};
  border-radius: 0;
  background: none;

  > img {
    width: 15px;
  }
`;

export const NoteCard = styled(Card)`
  margin-bottom: 0;
  padding: 16px 0 0 0;
  h1 {
    padding-left: 16px;
  }
`;

export const NoteCardTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
`;

export const NoteTitle = styled(Title)`
  padding-left: 16px;
  margin-bottom: 0;
`;

export const ModalTitle = styled(Title)`
  margin-bottom: 0;
`;
